var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeAllFunds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "111px",
    viewBox: "0 0 102 111",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "See All@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promo-Landing",
    transform: "translate(-1253.000000, -1825.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1689.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1230.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "See-All",
    transform: "translate(24.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFD100",
    points: "50.1882856 8.01897709 14.7922881 22.6823348 -1.13686838e-13 58.0153959 14.2046683 93.989378 49.901416 108.62069 85.1539788 92.9089683 99.9416399 57.5896412 85.8989141 22.6502887"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    stroke: "#C3D7EE",
    points: "50.1882856 -3.33955086e-13 14.7922881 14.6633577 -1.13686838e-13 49.9964188 14.2046683 85.9704009 49.901416 100.601713 85.1539788 84.8899912 99.9416399 49.5706641 85.8989141 14.6313116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2884293,57.3413996 L61.339948,57.3413996 L61.339948,47.021715 L64.2884293,47.021715 L64.2884293,40.0626225 L49.5460227,35.148247 L34.8036161,40.0626225 L34.8036161,47.021715 L37.7520975,47.021715 L37.7520975,57.3413996 L34.8036161,57.3413996 L34.8036161,62.5012419 L31.8551348,62.5012419 L31.8551348,70.6095655 L67.2369106,70.6095655 L67.2369106,62.5012419 L64.2884293,62.5012419 L64.2884293,57.3413996 Z M58.3914667,57.3413996 L54.705865,57.3413996 L54.705865,47.021715 L58.3914667,47.021715 L58.3914667,57.3413996 Z M51.7573837,57.3413996 L47.3346617,57.3413996 L47.3346617,47.021715 L51.7573837,47.021715 L51.7573837,57.3413996 Z M37.7520975,42.1868823 L49.5460227,38.2558138 L61.339948,42.1868823 L61.339948,44.0732337 L37.7520975,44.0732337 L37.7520975,42.1868823 Z M40.7005788,47.021715 L44.3861804,47.021715 L44.3861804,57.3413996 L40.7005788,57.3413996 L40.7005788,47.021715 Z M37.7520975,60.2898809 L61.339948,60.2898809 L61.339948,62.5012419 L37.7520975,62.5012419 L37.7520975,60.2898809 Z M64.2884293,67.6610842 L34.8036161,67.6610842 L34.8036161,65.4497232 L64.2884293,65.4497232 L64.2884293,67.6610842 Z",
    id: "Shape",
    fill: "#005587",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeAllFunds);
export default __webpack_public_path__ + "static/media/SeeAllFunds.16ef1e591abe74645e6ee722e5c0d286.svg";
export { ForwardRef as ReactComponent };